module.exports = __webpack_public_path__ + "img/08.b1571e81.jpg";